require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-introducing-the-code-fellows-diversity-scholarship-fund.json") })
        }
      }, "path---blog-introducing-the-code-fellows-diversity-scholarship-fund");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-introducing-the-code-fellows-diversity-scholarship-fund!./.cache/json/blog-introducing-the-code-fellows-diversity-scholarship-fund.json
// module id = 908
// module chunks = 231608221292675